import axios from './authService';
import API_ENDPOINTS from "../config/apiConfig";

export async function sendBugReport(payload) {
    try {
        const formData = new FormData();
        formData.append("title", payload.title);
        formData.append("description", payload.description);
        formData.append("priority", payload.priority);

        if (payload.epic_id) {
            formData.append("epic_id", payload.epic_id);
        }

        // Attachments (binary file)
        payload.attachments.forEach((file) => {
            formData.append("files[]", file, file.name);
        });

        const response = await axios.post(API_ENDPOINTS.REPORT_BUG, formData);
        return { success: true, data: response.data };
    } catch (error) {
        console.error("Bug report error:", error);

        // Case 1: Server responded with 413
        if (error?.response?.status === 413) {
            return {
                success: false,
                data: {
                    code: 413,
                    message:
                        "Attached file is too large. Please attach screenshots only.",
                },
            };
        }

        // Case 2: Request rejected before response (NGINX / proxy)
        if (
            error?.code === "ERR_NETWORK" ||
            error?.message?.includes("413") ||
            error?.message?.includes("Request Entity Too Large")
        ) {
            return {
                success: false,
                data: {
                    code: 413,
                    message:
                        "Attached file is too large. Please attach screenshots only.",
                },
            };
        }

        // Default fallback
        return {
            success: false,
            data: {
                message: "Failed to submit bug report. Please try again.",
            },
        };
    }
}